import { getImageUrl } from '@/constants/images'

import { useScreenSize } from '@/hooks/useScreenSize'

import styles from './index.module.scss'

export default function SplitLayout({
  children,
  leftContent,
  title = 'Expanding access to consumer credit.',
  subtitle = 'PayU Finance extends credit to Indian customers not covered by traditional banks via its various lending programs including unsecured personal loans. Now access finance and make payments in a way that suits you!'
}) {
  const { isDesktop } = useScreenSize()
  return (
    <div className={styles.container}>
      {isDesktop ? (
        <div className={styles.desktop}>
          {/* Left Side - Dynamic Content */}
          <div
            className={styles.leftPanel}
            style={{ backgroundImage: `url('${getImageUrl('splitLayoutBg')}')` }}>
            <img alt='icon' height={32} src={getImageUrl('logoPayuFinanceWhite')} width={139} />
            <div className={styles.content}>
              {leftContent || (
                <>
                  <img alt='icon' height={330} src={getImageUrl('bgIcon')} width={405} />
                  <h1 className='ew-typography-hero ew-fw-bold'>{title}</h1>
                  {subtitle ? (
                    <p className='ew-typography-small ew-fw-regular ew-mt-12'>{subtitle}</p>
                  ) : null}
                </>
              )}
            </div>
          </div>
          {/* Right Side - Main Content */}
          <div className={styles.rightPanel}>{children}</div>
        </div>
      ) : (
        children
      )}
    </div>
  )
}
